import script from "./ConfigPlanSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigPlanSection.vue?vue&type=script&setup=true&lang=js"

import "./ConfigPlanSection.vue?vue&type=style&index=0&id=6b285d18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b285d18"]])

export default __exports__